"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "frassinelle-polesine": {
    "bf1d09f8": [{
      "hkey": "4b21ed7a",
      "slug": "frassinelle-polesine",
      "name": "Frassinelle Polesine",
      "primary": true,
      "skipSearch": false
    }],
    "crosara": [{
      "hkey": "4b21ed7a",
      "slug": "frassinelle-polesine",
      "name": "Frassinelle Polesine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;